import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { allowedOrgsSupportCenter } from '@app/main/navigation-items';
import { UserService } from '@app/admin-station/work-center/user/services/user.service';
import { UserDTO } from '@app/shared/interfaces/user';

/**
 * Blocks a route to everyone except Innova's own internal staff (same root-org allowlist
 * Support Center's nav link uses - see allowedOrgsSupportCenter in navigation-items.ts).
 *
 * Waits for userLoginData$'s first real emission rather than reading a synchronous cache
 * snapshot (AuthService.getUserRootOrgIdFromCache()) - the external nav link that leads here
 * opens in a new tab (target="_blank"), which bootstraps the whole app from scratch, so a
 * synchronous read races the async login-data fetch and loses: the guard would see nothing
 * yet and redirect to /forbidden even for a legitimately allowed user, well before their
 * actual root org has loaded. Same fix FeatureFlagCanActivate already relies on for this
 * exact race.
 */
@Injectable({
  providedIn: 'root',
})
export class InnovaStaffCanActivate implements CanActivate {
  constructor(
    private _userService: UserService,
    private _router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this._userService.userLoginData$.pipe(
      filter(Boolean),
      take(1),
      map((userData: UserDTO) =>
        allowedOrgsSupportCenter.some((o) => o === userData.rootOrgId) ? true : this._router.createUrlTree(['/forbidden'])
      )
    );
  }
}
